import { render, staticRenderFns } from "./BaseInfoCard.vue?vue&type=template&id=6ccd2e8e&scoped=true"
import script from "./BaseInfoCard.vue?vue&type=script&lang=js"
export * from "./BaseInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccd2e8e",
  null
  
)

export default component.exports